class Button {
  constructor() {
    this.bindMethods()

    this.canFollowCursor = true
    this.direction = null
    this.stateForced = false
    this.isUnderline = false

    this.lastX = 0
    this.lastY = 0

    this.currentMousePosition = {
      x: 0,
      y: 0
    }

    this.cursorParams = {
      el: this.cursor,
      x: 0,
      y: 0,
      scale: 1,
      opacity: 0
    }

    this.options = {
      easing: 0.075
    }

    this.buttons = document.querySelectorAll('.cta, .icon-button')

    this.events()
  }

  bindMethods() {
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onClick = this.onClick.bind(this)
  }

  events() {
    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].addEventListener('mouseenter', this.onMouseEnter.bind(this, i))
      this.buttons[i].addEventListener('mouseleave', this.onMouseLeave)
      this.buttons[i].addEventListener('mousemove', this.onMouseMove)
      this.buttons[i].addEventListener('click', this.onClick)
    }
  }

  lerp(value1, value2, amount) {
    let amountValue = amount

    amountValue = amountValue < 0 ? 0 : amountValue
    amountValue = amountValue > 1 ? 1 : amountValue

    return (1 - amountValue) * value1 + amountValue * value2
  }

  onClick() {
    this.cursorParams.scale = 5
  }

  onMouseEnter(i) {
    if (this.buttons[i].classList.contains('underline')) return

    this.stateForced = false

    this.buttonRect = this.buttons[i].getBoundingClientRect()
    this.isUnderline = this.buttons[i].classList.contains('underline')
    this.shape = this.buttons[i].querySelector('.shape')
    this.svg = this.shape.querySelector('svg')
    this.shapeSize = this.shape.offsetWidth

    this.cursorParams.opacity = 1
  }

  onMouseLeave() {
    // const center = {
    //   x: -this.shapeSize / 2,
    //   y: -this.shapeSize / 2
    // }

    // this.moveTo({
    //   x: center.x,
    //   y: center.y
    // })

    this.cursorParams.opacity = 0
    // this.stateForced = true
    this.isUnderline = false
  }

  onMouseMove(event) {
    if (!this.canFollowCursor) return

    this.updateCursorPosition(event.clientX, event.clientY)
  }

  updateCursorPosition(x, y) {
    if (x) this.cursorParams.x = x
    if (y) this.cursorParams.y = y
  }

  moveTo({ x, y }) {
    this.updateCursorPosition(x, y)
  }

  scaleTo(value) {
    this.cursorParams.scale = value
  }

  update() {
    if (!this.shape) return

    const cursorX = this.stateForced ? this.cursorParams.x : Number(this.cursorParams.x - this.shapeSize / 2 - this.buttonRect.left - this.buttonRect.width / 2)
    const cursorY = this.stateForced ? this.cursorParams.y : Number(this.cursorParams.y - this.shapeSize / 2 - this.buttonRect.top - this.buttonRect.height / 2)

    const translateX = this.lerp(this.lastX, cursorX, this.options.easing)
    const translateY = this.lerp(this.lastY, cursorY, this.options.easing)

    this.shape.style.transform = 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0)'
    this.shape.style.opacity = this.cursorParams.opacity

    this.lastX = this.lerp(translateX, cursorX, this.options.easing)
    this.lastY = this.lerp(translateY, cursorY, this.options.easing)

    const transformValue = this.shape.style.transform
    const transform = transformValue.substring(12).split('px')

    this.currentMousePosition.x = Number(transform[0]) + this.cursorSize / 2
    this.currentMousePosition.y = Number(transform[1].substring(2)) + this.cursorSize / 2
  }
}
export default Button



// WEBPACK FOOTER //
// ./scripts/util/Button.js